import React from 'react'
import { createPaginationModel, PaginationItem } from './../../src/Helper/ViewTransactions'
import './ViewTransactionResultPagination.css'

interface PaginationProps {
  currentPage: number
  totalItemCount: number
  onPageChange: (page: number) => void
  itemsPerPage?: number
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItemCount,
  onPageChange,
  itemsPerPage = 50,
}) => {
  const totalPages = Math.ceil(totalItemCount / itemsPerPage)

  const pageItems = createPaginationModel(totalPages, currentPage)

  const gotoNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }

  const gotoPrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }

  const isEllipsis = (pageItem: PaginationItem) => {
    return pageItem.type === 'ellipsis'
  }

  const gotoPage = (pageItem: PaginationItem) => {
    if (!isEllipsis(pageItem)) {
      onPageChange(Number(pageItem.value))
    }
  }

  const getIsActivePage = (item: PaginationItem, currentPage: number) => {
    const isActivePage = Number(item.value) === currentPage
    return isActivePage ? 'active' : ''
  }

  const getIsEllipsisPage = (item: PaginationItem) => {
    return isEllipsis(item) ? 'ellipsis' : ''
  }

  return (
    <div className="pagination-container">
      <ul className="pagination-list">
        <li
          onClick={gotoPrevPage}
          className={`pagination-item ${currentPage === 1 ? 'disabled' : ''}`}
        >
          &larr; Previous
        </li>

        {pageItems.map((item: PaginationItem, index) => {
          const activeOrNot = getIsActivePage(item, currentPage)
          const ellipsisOrNot = getIsEllipsisPage(item)
          const clsName = `pagination-item ${activeOrNot} ${ellipsisOrNot}`

          return (
            <li key={index}
              onClick={() => gotoPage(item)}
              className={clsName}
            >
                {item.value}
            </li>
          )
        })}

        <li
          onClick={gotoNextPage}
          className={`pagination-item ${currentPage === totalPages ? 'disabled' : ''}`}
        >
          Next &rarr;
        </li>
      </ul>
    </div>
  )
}
